import React, { useState, useEffect } from "react";
import Pagination from "../../../../components/global/pagination/Pagination.jsx";
import columns from "../../../../columns/wallet/Withdraw/pending.js";
import ModalComponent from "../../../../components/global/modal/ModalComponent.jsx";
import TableWithSkeleton from "../../../../components/global/table/TableWithSkeleton.jsx";
import ConfirmationModal from "../../../../components/global/modal/ConfirmationModal.jsx";
import Eye from "../../../../assets/Eye.jsx";
import { GetAllAccountApi, RequestAcceptRejectApi } from "../../../../api/request/wallet/withdraw.js";
import moment from "moment";
import toast from "react-hot-toast";
import Copytest from "../../../../components/copy/Copy.jsx"
import Copy from '../../../../components/copy/Copy.jsx';
import { useSelector } from "react-redux";
import Report from "../../../../assets/Report.jsx";
import { useNavigate } from 'react-router-dom';
import FullyKycBadge from "../../../../components/kyc/FullyKycFlag.jsx";

export default function Withdraw({ search, dates }) {
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state.user.userDetails);
    let isSalesManager = userDetails?.roleId === 6;

    const [pageSize, setPageSize] = useState(10);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [requestRejection, setrequestRejection] = useState(false);
    const [requestAccept, setrequestAccept] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [selectedIBId, setSelectedIBId] = useState(null)
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [isReqLoading, setIsReqLoading] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [referenceId, setReferenceId] = useState('');
    const [withdrawdetails, setWithdrawdetails] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [approveItems, setApproveItems] = useState([]);
    const [sorter, setSorter] = useState({ SortBy: 'requestDate', SortOrder: '' });

    const truncateString = (str) => {
        let string = str?.toString();
        return string?.substring(0, 6) + '...';
    };

    const handleClick = (item) => {
        setSelectedIBId({ userId: item?.userId, TransactionId: item?.requestId });
        setIsOpenModal(true);
    };

    const Withdrawrequest = (item) => {
        setSelectedRowKeys([item?.requestId]);
        setApproveItems([item]);
        setrequestAccept(true);
    };

    const WithdrawrequestReject = (item) => {
        setSelectedRowKeys([item?.requestId]);
        setrequestRejection(true);
    };

    const getAllWithdraw = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: search,
                FilterText: "pending",
                FromDate: dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            key: item?.requestId,
                            name: `${item?.firstName} ${item?.lastName}`,
                            balance: `$ ${item?.balance}`,
                            amount: `$ ${item?.amount}`,
                            requestDate: moment(item?.requestDate).format('DD-MM-YYYY, hh:mm A'),
                            actionDate: moment(item?.actionDate).format('DD-MM-YYYY, hh:mm A'),
                            actions: (
                                <div className="flex">
                                    <button type="button" onClick={() => { setWithdrawdetails(item); handleClick(item); }}><Eye /></button>
                                    <button className="mr-3 ml-3" onClick={() => Withdrawrequest(item)} ><img src="assets/icons/accept_icon.svg" className="min-w-6 max-w-6" alt="icon" /></button>
                                    <button onClick={() => WithdrawrequestReject(item)}><img src="assets/icons/delete_icon.svg" className="min-w-6 max-w-6" alt="icon" /></button>
                                    <button type="button" className="mr-3 ml-3 min-w-6 max-w-6" onClick={() => { navigate(`/scalping_report/${item?.userId}`); }}><Report /></button>
                                </div>
                            ),
                            address: (
                                <div className="flex">

                                    <p>{truncateString(item?.thirdPartyWalletAddress)}</p>
                                    <Copytest text={item?.thirdPartyWalletAddress} />

                                </div>
                            )

                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllWithdraw();
    }, [page, pageSize, dates, search, sorter]);

    useEffect(() => {
        setPage(1);
    }, [search]);

    const hideTransactionHash = approveItems.length > 0 && approveItems.every((item) => item?.withdrawType === "UPS");

    const RequestHandlerApproved = async () => {
        try {
            setIsReqLoading(true);
            let params = {
                WithdrawalRequestId: selectedRowKeys,
                IsApprovedRejected: true,
                ...(!hideTransactionHash && referenceId && { referenceId }),
            }
            const { data } = await RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                setSelectedRowKeys([])
            }
            getAllWithdraw();
            setReferenceId('');
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        setrequestAccept(false);
    }

    const RequestHandlerReject = async (value) => {
        if (!value) {
            if (!textAreaValue) {
                toast.error('Please enter a reason.');
                return;
            }
        }
        try {
            setIsReqLoading(true);
            let params = {
                WithdrawalRequestId: selectedRowKeys,
                IsApprovedRejected: false,
                comment: textAreaValue,
            }
            const { data } = await RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                setSelectedRowKeys([])
            }
            getAllWithdraw();
            setTextAreaValue('');
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        setrequestRejection(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'requestDate', SortOrder: '' });
        }
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const inrAmount = Math.trunc(Number(withdrawdetails?.currency) || 0);

    const formattedBankTransferCopy = `
#${withdrawdetails?.amount}
NAME - ${withdrawdetails?.name}
ACCOUNT - ${withdrawdetails?.bankAccountNumber}
IFSC - ${withdrawdetails?.ifscCode}
BANK NAME - ${withdrawdetails?.bankName}
MOB - ${withdrawdetails?.mobileNumber}
EMAIL - ${withdrawdetails?.email}
INR - ${inrAmount}
`.trim();

    const formattedCashCopy = `
#${withdrawdetails?.amount}
NAME - ${withdrawdetails?.name}
MOB - ${withdrawdetails?.mobileNumber}
INR - ${inrAmount}
`.trim();


    return (
        <div>
            <div className="flex flex-col gap-5">
                {selectedRowKeys.length && !isSalesManager ? (
                    <div className="flex justify-end px-4 lg:px-6">
                        <div className="flex justify-center items-center gap-3">
                            <button
                                className="bg-[#2D9B6333] text-sm text-[#2D9B63] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#2D9B63] hover:text-white duration-500"
                                onClick={() => {
                                    const items = data.filter((row) => selectedRowKeys.includes(row.requestId) || selectedRowKeys.includes(row.key));
                                    setApproveItems(items);
                                    setrequestAccept(true);
                                }}
                            >
                                Accept
                            </button>
                            <button
                                className="bg-[#F8222333] text-sm text-[#F82223] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#F82223] hover:text-white duration-500"
                                onClick={() => setrequestRejection(true)}
                            >
                                Reject
                            </button>
                        </div>
                    </div>
                ) : null}

                <div>
                    <TableWithSkeleton
                        columns={columns}
                        data={data}
                        rowSelection={!isSalesManager ? rowSelection : null}
                        loading={isLoading} onChange={handleTableChange}
                        hiddenColumns={isSalesManager ? ["Actions"] : []}
                        page={page}
                        pageSize={pageSize}
                        index={true}
                    />
                    <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                </div>
            </div>

            {/* ---- Withdraw Information ---- */}
            <ModalComponent
                isOpen={isOpenModal}
                setIsOpen={setIsOpenModal}
                title='Withdraw Information'
                width={1300}
            >
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                        {withdrawdetails?.firstName ? <div>
                            <p className='text-description font-normal'>First Name</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.firstName || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.lastName ? <div>
                            <p className='text-description font-normal'>Last Name</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.lastName || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.mobileNumber ? <div>
                            <p className='text-description font-normal'>Mobile Number</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.mobileNumber || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.email ? <div>
                            <p className='text-description font-normal'>Email</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.email || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.withdrawType ? <div>
                            <p className='text-description font-normal'>Withdraw Type</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.withdrawType || '---'}</p>
                        </div> : ""}
                        <div>
                            <p className='text-description font-normal'>Fully KYC</p>
                            <div className='mt-2'><FullyKycBadge value={withdrawdetails?.isFullyKyc} size="lg" /></div>
                        </div>
                        {withdrawdetails?.walletAccountNo ? <div>
                            <p className='text-description font-normal'>Wallet Account No.</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.walletAccountNo || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.bankAccountNumber ? <div>
                            <p className='text-description font-normal'>Bank Account Number</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.bankAccountNumber || '---'}</p>
                        </div> : ""}
                        {/* {withdrawdetails?.balance ? <div>
                            <p className='text-description font-normal'>Wallet Balance</p>
                            <p className='text-description primary font-semibold mt-2'>$ {withdrawdetails?.balance || '---'}</p>
                        </div> : ""} */}
                        {withdrawdetails?.amount ? <div>
                            <p className='text-description font-normal'>Amount</p>
                            <p className='text-description primary font-semibold mt-2'>$ {withdrawdetails?.amount || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.withdrawType === 'RMDT_Token' ? <div>
                            <p className='text-description font-normal'>RMDT Amount</p>
                            <p className='text-description primary font-semibold mt-2'>{(withdrawdetails?.amount * withdrawdetails?.currencyRate).toFixed(2) || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.requestDate ? <div>
                            <p className='text-description font-normal'>Created Time</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.requestDate ? moment(withdrawdetails?.requestDate).format('DD-MM-YYYY, hh:mm A') : '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.bankBranchAddress ? <div>
                            <p className='text-description font-normal'>Bank Branch Address</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.bankBranchAddress || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.bankName ? <div>
                            <p className='text-description font-normal'>Bank Name</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.bankName || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.iban ? <div>
                            <p className='text-description font-normal'>IBAN</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.iban || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.ifscCode ? <div>
                            <p className='text-description font-normal'>IFSC Code</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.ifscCode || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.swifT_BIC_Code ? <div>
                            <p className='text-description font-normal'>Swift BIC Code</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.swifT_BIC_Code || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.cryptoWalletAddress ? <div>
                            <p className='text-description font-normal'>Wallet Address</p>
                            <div className="flex items-center gap-3">
                                <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.cryptoWalletAddress || '---'}</p>
                                <Copy text={withdrawdetails?.cryptoWalletAddress} />
                            </div>
                        </div> : ""}
                        {withdrawdetails?.paypalEmail ? <div>
                            <p className='text-description font-normal'>Paypal Email</p>
                            <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.paypalEmail || '---'}</p>
                        </div> : ""}
                        {withdrawdetails?.upiId ? <div>
                            <p className='text-description font-normal'>UPI Id</p>
                            <div className="flex items-center gap-3">
                                <p className='text-description primary font-semibold mt-2'>{withdrawdetails?.upiId || '---'}</p>
                                <Copy text={withdrawdetails?.upiId} />
                            </div>
                        </div> : ""}

                        {(withdrawdetails?.withdrawType === "BankTransfer" || withdrawdetails?.withdrawType === "Cash") && <div>
                            <Copy text={withdrawdetails?.withdrawType === "Cash" ? formattedCashCopy : formattedBankTransferCopy} ><button className="bg-primary text-white px-4 py-2 rounded-md">Copy Information</button> </Copy>
                        </div>}

                    </div>
                </div>
            </ModalComponent>

            {/* ---- Reject-request ---- */}
            <ConfirmationModal
                isOpen={requestRejection}
                setIsOpen={setrequestRejection}
                message='Are you sure you want to reject this request?'
                onConfirm={() => RequestHandlerReject(true)}
                isLoading={isReqLoading}
                loadingLabel='Rejecting request...'
                textArea={true}
                textAreaValue={textAreaValue}
                setTextAreaValue={setTextAreaValue}
                placeholder='Reason of rejection...'
            />


            {/* ---- Accept-request ---- */}
            <ConfirmationModal
                isOpen={requestAccept}
                setIsOpen={(val) => {
                    setrequestAccept(val);
                    if (!val) {
                        setReferenceId('');
                        setApproveItems([]);
                    }
                }}
                type='success'
                message='Are you sure you want to withdraw this request?'
                onConfirm={() => RequestHandlerApproved(true)}
                isLoading={isReqLoading}
                loadingLabel='Accepting request...'
                textArea={!hideTransactionHash}
                textAreaValue={referenceId}
                setTextAreaValue={setReferenceId}
                placeholder='Enter transaction hash'
                textAreaRows={1}
                extraContent={
                    <div className="flex items-center justify-between gap-3 rounded-lg bg-[#F6F6F8] px-4 py-3 mb-3">
                        <p className="text-sm font-semibold text-[#2F2B3D]">Fully KYC</p>
                        {approveItems.length > 1 && new Set(approveItems.map((item) => Boolean(item?.isFullyKyc))).size > 1 ? (
                            <span className="text-xs text-[#8A8894]">Mixed across selected requests</span>
                        ) : (
                            <FullyKycBadge value={approveItems[0]?.isFullyKyc} size="lg" />
                        )}
                    </div>
                }
            />
        </div>
    )
}
